"use strict";

define('libs/format/reviewType',['underscore', 'handlebars', './empty'], function (_, Handlebars, emptyFormatter) {
  var empty = emptyFormatter(new Handlebars.SafeString('<i>N/A</i>'));
  var reviewTypeFormatter = function reviewTypeFormatter(value) {
    if (!value) {
      return empty(value);
    }
    var icon = '';
    switch (value) {
      case 'Full':
        icon = 'teal users';
        break;
      case 'Expedited':
        icon = 'blue rocket';
        break;
      case 'Exempt':
        icon = 'user';
        break;
    }
    if (value == 'Unassigned') {
      return new Handlebars.SafeString('<i>N/A</i>');
    }
    return value;
    return new Handlebars.SafeString(['<span>', icon ? '<i class="' + icon + ' icon"></i>' : '', Handlebars.escapeExpression(value), '</span>'].join(''));
  };
  return reviewTypeFormatter;
});

